import { render, staticRenderFns } from "./IconPlusSolid.vue?vue&type=template&id=914dfbb6"
import script from "./IconPlusSolid.vue?vue&type=script&lang=js"
export * from "./IconPlusSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports